import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	savingMessage: {
		id: 'save-indicator.saving',
		description: 'Save indicator message after user types or edits.',
		defaultMessage: 'Saving',
	},
	allChangesSavedMessage: {
		id: 'save-indicator.all.changes.saved',
		description: 'Save indicator message when user opens an existing page in editor or is idle.',
		defaultMessage: 'Saved',
	},
	savedTooltipMessage: {
		id: 'save-indicator.all.changes.saved.tooltip',
		description: 'Tooltip message of save indicator to indicate all changes are saved.',
		defaultMessage: 'Every change is saved, the last change was {time}',
	},
	errorTooltipMessage: {
		id: 'save-indicator.error.tooltip',
		description: 'Tooltip message of save indicator to indicate an error.',
		defaultMessage: 'We couldn’t save the latest changes. The last save was {time}',
	},
	aMomentAgo: {
		id: 'save-indicator.tooltip.time.aMomentAgo',
		description:
			'Time string in save indicator tooltip that indicates last change was a moment ago',
		defaultMessage: 'just a moment ago',
	},
	lessThanAMinuteAgo: {
		id: 'save-indicator.tooltip.time.lessThanAMinuteAgo',
		description:
			'Time string in save indicator tooltip that indicates last change was less than a minute ago',
		defaultMessage: 'less than a minute ago',
	},
	oneMinuteAgo: {
		id: 'save-indicator.tooltip.time.oneMinuteAgo',
		description:
			'Time string in save indicator tooltip that indicates last change was one minute ago',
		defaultMessage: 'a minute ago',
	},
	xMinutesAgo: {
		id: 'save-indicator.tooltip.time.xMinutesAgo',
		description:
			'Time string in save indicator tooltip that indicates last change was several minutes ago',
		defaultMessage: '{time} minutes ago',
	},
	oneHourAgo: {
		id: 'save-indicator.tooltip.time.oneHourAgo',
		description:
			'Time string in save indicator tooltip that indicates last change was about one hour ago',
		defaultMessage: 'about an hour ago',
	},
	xHoursAgo: {
		id: 'save-indicator.tooltip.time.xHoursAgo',
		description:
			'Time string in save indicator tooltip that indicates last change was about several hour ago',
		defaultMessage: 'about {time} hours ago',
	},
	yesterday: {
		id: 'save-indicator.tooltip.time.yesterday',
		description:
			'Time string in save indicator tooltip that indicates last change was the day before',
		defaultMessage: 'yesterday at {time}',
	},
});
